import { Base } from "../../../../base/components/base"
import { rateTdStyle } from "./rate-td.style"

export const RateTd = () => {
    const base = Base('td')

    base.cssClass(rateTdStyle)

    return base
}